import { render, staticRenderFns } from "./DetailMultbanck.vue?vue&type=template&id=7d9f8cf7&scoped=true&"
import script from "./DetailMultbanck.vue?vue&type=script&lang=js&"
export * from "./DetailMultbanck.vue?vue&type=script&lang=js&"
import style0 from "./DetailMultbanck.vue?vue&type=style&index=0&id=7d9f8cf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9f8cf7",
  null
  
)

export default component.exports